var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plan" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showTitle,
            expression: "showTitle",
          },
        ],
        staticClass:
          "titolo navy--text text--lighten-2 font-hemi-head pb-4 d-flex align-center",
      },
      [
        _c("div", { staticClass: "mr-2" }, [_vm._v("Pianificazione")]),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "primary font-hemi-head",
            attrs: { small: "", depressed: "" },
            on: { click: _vm.swithToRose },
          },
          [
            _c("v-icon", { attrs: { small: "" } }, [_vm._v("arrow_forward")]),
            _vm._v(" Rose\n    "),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    !_vm.my_squadra
      ? _c("div", { staticClass: "pa-10" }, [
          _vm._v(
            "\n      Attenzione. Solo i partecipanti all'asta possono pianificare le\n      strategia di acquisto\n    "
          ),
        ])
      : _c(
          "div",
          [
            _c("asta-consiglio"),
            _vm._v(" "),
            _c(
              "v-list",
              {
                staticClass: "recycle-scroller",
                class: { "nice-scroll": !_vm.is_mobile },
              },
              _vm._l(_vm.myPlan, function (slots, ruolo_abc) {
                return _c(
                  "div",
                  { key: ruolo_abc },
                  _vm._l(slots, function (slotData, slot, i) {
                    return _c("asta-slot", {
                      key: ruolo_abc + "_" + slot,
                      attrs: { ruolo_abc: ruolo_abc, iSlot: slot, i: i },
                    })
                  }),
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("asta-plan-numpad"),
            _vm._v(" "),
            _c("dialog-associa-calciatore"),
            _vm._v(" "),
            _c("dialog-associa-slot"),
            _vm._v(" "),
            _c("dialog-plan-settings"),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }